// =======================
// == Animations/SearchResults.js ==
// =======================
/*
  All of the animations for SearchResults.js
*/

import Animator from './animator';

const animator = new Animator();

const animate = fail => {
  animator
    .call('#failureCount', {
      innerHTML: fail,
      round: 1,
      easing: 'easeInQuad',
      delay: 500,
      duration: 1500,
    })
    .call('#unlockForm', animator.animations.downAndFadeOut);
};

export default animate;
